import { AutoComplete, DatePicker, Form, Input, Select, Modal } from "antd";
import React, { createRef, useEffect, useRef, useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import AddButton from "../../../../Componets/Buttons/add";
import { select_id, select_search } from "../../../../Controllers/Global";
import dayjs from "dayjs";
import moment from "moment";
import taxes from "../../../taxes.json";
import payment_types from "../../../payment_types.json";
import {
  get_product,
  get_product_barcode,
} from "../../../../Controllers/Products/Products";
import Error from "../../../../Componets/Error";
import Modalcomponent from "../../../../Componets/Modal";
import Required from "../../../../Componets/Required";
import { isCancel } from "axios";
import {
  handleDateKeyDown,
  handleDateInput,
  handleDateBlur,
  blockPaste,
  handleDateInputDebounced,
} from "../../../../Componets/Formcomponents/dateUtility";
import formatDateDDMMYYYY from "../../../../Main/formatDate";
import UserCurrency from "../../../../Componets/UserCurrency";
import { get_user_auth } from "../../../../Controllers/Layouts/Layouts";
import PlusButton from "../../../../Componets/Buttons/plus";
import ProductsForm from "../../../../Pages/Products/Products/Form";

const Purchaseordertable = React.forwardRef((props, focus) => {
  const { details, setDetails, totals, setTotals } = props;

  console.log("details in table", details);

  focus.current[`delivery_date`] = createRef();
  focus.current[`payment_types`] = createRef();

  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const [selectedModalData, setSelectedModalData] = useState();
  const [taxOptions, setTaxOptions] = useState({});
  const [authorizeMail, setAuthorizeMail] = useState(false);
  const [productModalOpen, setProductModalOpen] = useState(false);
  const [currentProductIndex, setCurrentProductIndex] = useState(null);

  const fetchCategoryForExistingData = async () => {
    if (!details || details.length === 0) return;

    const updatedDetails = [...details];
    let needsUpdate = false;

    for (let i = 0; i < updatedDetails.length; i++) {
      const item = updatedDetails[i];
      if (item.description && !item.tax_category) {
        try {
          const inventory = await get_product(item.description);
          if (inventory?.status && inventory?.data?.category?._id) {
            const category = inventory.data.category._id;
            updatedDetails[i].tax_category = category;
            needsUpdate = true;

            await fetchTaxOptions(category, i);
          }
        } catch (error) {
          console.error(`Error fetching category for item ${i}:`, error);
        }
      }
    }

    if (needsUpdate) {
      setDetails(updatedDetails);
    }
  };

  const fetchAuthorizeUser = async () => {
    try {
      const response = await get_user_auth();
      if (response?.status) {
        const authorize_email =
          response?.data?.branch?.plan === 3000 && response?.data?.email?.trim().toLowerCase() ===
          process.env.REACT_APP_CROWN_PHARMACY_EMAIL?.trim().toLowerCase();

        setAuthorizeMail(authorize_email);
      } else {
        toast?.error(response?.message || "Failed to fetch User Auth");
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchCategoryForExistingData();
    fetchAuthorizeUser();
  }, []);

  const fetchTaxOptions = async (category, index) => {
    if (!category) return;

    try {
      const select = {
        api: "get-all-taxes",
        search: "",
        status: 1,
        source: "Inventory",
        category: category,
      };

      const search = await select_search(select);
      if (search?.status || search?.success) {
        let options = [];
        search?.data?.data?.map((value, index) => {
          options?.push({
            value: value?._id,
            label: value?.name,
            rate: value?.rate,
          });
        });

        setTaxOptions((prev) => ({
          ...prev,
          [category]: options,
        }));

        let data = [...details];
        if (data[index]?.tax_category === category) {
          data[index].tax_options = options;
          setDetails(data);
        }
      }
    } catch (error) {
      console.error("Error fetching tax options:", error);
    }
  };

  const getTaxOptionsForRow = (index) => {
    const data = [...details];
    const category = data[index]?.tax_category;

    if (category && taxOptions[category]) {
      return taxOptions[category];
    }

    return data[index]?.tax_options || [];
  };

  const handleTaxSearch = async (e, index) => {
    let data = [...details];
    let category = data[index]?.tax_category;

    if (!category && data[index]?.description) {
      try {
        if (data[index]?.product_details?.category?._id) {
          category = data[index].product_details.category._id;
          data[index].tax_category = category;
          setDetails(data);
        }
      } catch (error) {
        console.error("Error fetching category for tax search:", error);
      }
    }

    const select = {
      api: "get-all-taxes",
      search: e,
      status: 1,
      source: "Inventory",
      category: category ? category : "",
    };

    const search = await select_search(select);

    if (search?.status || search?.success) {
      let options = [];
      search?.data?.data?.map((value, index) => {
        options?.push({
          value: value?._id,
          label: value?.name,
          rate: value?.rate,
        });
      });

      data[index].tax_options = options;
      setDetails(data);

      setTaxOptions((prev) => ({
        ...prev,
        [category]: options,
      }));
    } else {
      toast?.error("Failed to load tax options");
    }
  };

  const searchTimers = useRef({});
  const barcodeInputRef = useRef(null);
  const isScanning = useRef(false);
  const currentScanIndex = useRef(null);

  useEffect(() => {
    let barcode = "";
    let timeout;

    const handleScannerInput = (e) => {
      if (
        e.target.tagName === "INPUT" ||
        e.target.tagName === "TEXTAREA" ||
        e.target.tagName === "SELECT"
      ) {
        return;
      }

      if (e.key.length === 1) {
        isScanning.current = true;
        barcode += e.key;
        clearTimeout(timeout);
        timeout = setTimeout(async () => {
          if (barcode.length >= 6) {
            await handleBarcodeScan(barcode);
            barcode = "";
          }
        }, 100);
      }
    };

    window.addEventListener("keydown", handleScannerInput);

    return () => {
      window.removeEventListener("keydown", handleScannerInput);
    };
  }, [details]);

  useEffect(() => {
    if (
      totals?.payment_types?.includes("Cash") &&
      (!totals.payments || totals.payments.length === 0)
    ) {
      const updatedPayments = [
        {
          id: `temp-cash-${Date.now()}`,
          name: "Cash",
          amount: "",
        },
      ];

      totals.payments = updatedPayments;
      setTotals({ ...totals });
    }
  }, [totals?.payment_types]);

  const handleBarcodeScan = async (barcode) => {
    if (!barcode) return;

    isScanning.current = true;
    console.log("SCAN STARTED - isScanning set to TRUE");

    try {
      console.log("Scanning barcode:", barcode);
      const res = await get_product_barcode({ barcode });

      if (res?.status && res?.data) {
        const product = res.data;
        console.log("Scanned Product:", product);

        let index = details.findIndex((d) => !d.description);
        console.log("Found empty row at index:", index);

        if (index === -1) {
          handleAdd();
          index = details.length;
        }

        const productOption = {
          value: product._id,
          label: product.name,
          data: product,
        };

        const rowData = {
          description: product._id,
          name: product.name,
          barcode: product.barcode,
          unit_name: product.unit?.name || "",
          quantity: 1,
          purchase_price: product.purchase_price || 0,
          sale_price: product.sale_price || 0,
          sale_options: [],
          wholesale_price: product.wholesale_price || 0,
          tax: product?.tax
            ? {
              id: product.tax._id,
              name: product.tax.name,
              rate: product.tax.rate,
            }
            : null,
          tax_details: product?.tax,
          tax_category: product?.category?._id || null,
          options: [productOption],
        };

        const newDetails = [...details];
        newDetails[index] = {
          ...newDetails[index],
          ...rowData,
        };

        console.log("Setting details with scanned product:", newDetails[index]);
        setDetails(newDetails);

        if (product?.category?._id) {
          fetchTaxOptions(product.category._id, index);
        }

        if (searchTimers.current[index]) {
          clearTimeout(searchTimers.current[index]);
          delete searchTimers.current[index];
        }

        setTimeout(() => {
          if (focus.current[`batch${index}`]?.current) {
            focus.current[`batch${index}`].current.focus();
          }

          isScanning.current = false;
          console.log("SCAN COMPLETED, isScanning reset to FALSE");
        }, 100);
      } else {
        toast.error("Product not found");
        isScanning.current = false;
      }
    } catch (err) {
      console.error(err);
      toast.error("Error scanning barcode");
      isScanning.current = false;
    }
  };

  const refreshProducts = async (index) => {
    let data = [...details];

    const select = {
      api: "get-all-products",
      search: "",
      status: 1,
    };

    const search = await select_search(select);

    if (search?.status) {
      let options = [];
      search?.data?.data?.map((value, idx) => {
        options?.push({ data: value, value: value?._id, label: value?.name });
      });

      data[index].options = options;
      setDetails(data);
    }
  };

  const handleOpenProductModal = (index) => {
    setCurrentProductIndex(index);
    setProductModalOpen(true);
  };

  const handleProductModalClose = async () => {
    setProductModalOpen(false);
    if (currentProductIndex !== null) {
      await refreshProducts(currentProductIndex);
      setCurrentProductIndex(null);
    }
  };

  const handleSearch = async (e, index) => {
    if (isScanning.current) {
      return;
    }

    console.log("Search Input:", e, "Index:", index);

    const searchTerm = e?.trim() || "";

    if (searchTerm.length >= 6 && /^\d+$/.test(searchTerm)) {
      console.log("Detected barcode in search:", searchTerm);
      return;
    }

    if (searchTimers.current[index]) {
      clearTimeout(searchTimers.current[index]);
    }

    searchTimers.current[index] = setTimeout(async () => {
      let data = [...details];

      const select = {
        api: "get-all-products",
        search: searchTerm,
        status: 1,
      };

      const search = await select_search(select);

      console.log("Search Result:", search);

      if (search?.status) {
        let options = [];
        search?.data?.data?.map((value, index) => {
          options?.push({ data: value, value: value?._id, label: value?.name });
        });

        data[index].options = options;
        setDetails(data);
      } else {
        toast?.error(search?.message);
      }
    }, 300);
  };

  const handleDescription = async (e, index, product_data) => {
    if (isScanning.current) {
      return;
    }

    let data = [...details];

    console.log("Description Selected:", e, product_data);

    if (e) {
      let params = {
        id: e,
      };

      const product = {
        status: true,
        data: product_data?.data,
      };

      let product_tax_category = product?.data?.category?._id;

      let product_tax = product?.data?.tax
        ? {
          id: product?.data?.tax?._id,
          rate: product?.data?.tax?.rate,
          name: product?.data?.tax?.name,
        }
        : null;

      if (product?.data?.product_units_details?.length > 0) {
        setOpen(true);
        setModalData([
          { ...product?.data?.unit, _id: product?.data?._id },
          ...product?.data?.product_units_details,
        ]);

        setSelectedModalData({ ...product, index: index });
      } else {
        let description_ids = [];

        data?.map((v, i) => {
          description_ids?.push(v?.description);
        });

        let product_description = product?.data?._id;
        let product_name = product?.data?.name;
        let product_unit = product?.data?._id;
        let product_unit_name = product?.data?.unit?.name;
        let sale_price = product?.data?.sale_price;
        let wholesale_price = product?.data?.wholesale_price;
        let purchase_price = product?.data?.purchase_price;

        let product_unit_details = [];
        if (product?.data?.product_units_details?.length > 0) {
          product?.data?.product_units_details?.map((value, index) => {
            product_unit_details?.push({
              ...value,
              name: value?.name?.name,
              price_per_unit: 0,
              sale_price: value?.sale_price,
              unit_quantity: 0,
              unit_delivered: 0,
            });
          });
        }

        data[index].description = product_description;
        data[index].name = product_name;
        data[index].unit = product_unit;
        data[index].unit_name = product_unit_name;
        data[index].quantity = "";
        data[index].unit_details_options = product_unit_details;
        data[index].purchase_price = purchase_price;
        data[index].sale_price = sale_price;
        data[index].wholesale_price = wholesale_price;
        data[index].tax = product_tax;
        data[index].tax_category = product_tax_category;

        if (product_tax_category) {
          fetchTaxOptions(product_tax_category, index);
        }

        data[index].options = [
          { value: product_description, label: product_name, data: product },
        ];

        setDetails(data);

        focus.current[`batch${index}`].current.focus();
      }
    } else {
      data[index].id = "";
      data[index].description = null;
      data[index].name = "";
      data[index].unit = "";
      data[index].unit_name = "";
      data[index].unit_details_options = null;
      data[index].quantity = "";
      data[index].conversion = 0;
      data[index].purchase = "";
      data[index].purchase_price = "";
      data[index].purchase_options = null;
      data[index].delivered = "";
      data[index].tax = null;
      data[index].tax_category = "";
      data[index].tax_options = null;
      data[index].free = "";
      data[index].barcode = "";
      data[index].price_per_unit = "";
      data[index].sale_price = "";
      data[index].expiry_date = "";
      data[index].tax_amount = "0.000";
      data[index].total = 0;
      setDetails(data);
    }
  };

  const handleSelectKeyDown = async (e, index) => {
    if (
      e.key === "Enter" &&
      e.target.value &&
      e.target.value.length >= 6 &&
      /^\d+$/.test(e.target.value)
    ) {
      e.preventDefault();
      console.log("Manual barcode entry in select:", e.target.value);
      await handleBarcodeScan(e.target.value);
    }
  };

  const handleModal = (modaldata) => {
    let data = [...details];

    let product = selectedModalData;
    let index = selectedModalData?.index;

    console.log("modal selected", product);

    let product_description = null;
    let product_name = "";
    let product_unit = "";
    let product_unit_name = "";
    let product_conversion = 0;
    let product_unit_details = [];
    let sale_price = 0;
    let purchase_price = 0;
    let wholesale_price = 0;
    let product_tax = product?.data?.tax
      ? {
        id: product?.data?.tax?._id,
        rate: product?.data?.tax?.rate,
        name: product?.data?.tax?.name,
      }
      : null;
    let product_tax_category = product?.data?.category?._id;

    let description_ids = [];

    data?.map((v, i) => {
      description_ids?.push(v?.unit);
    });

    if (product?.data?._id == modaldata) {
      product_description = product?.data?._id;
      product_name = product?.data?.name;
      product_unit = modaldata;
      product_unit_name = product?.data?.unit?.name;
      purchase_price = product?.data?.purchase_price;
      sale_price = product?.data?.sale_price;
      wholesale_price = product?.data?.wholesale_price;
      product_tax = product?.data?.tax;

      if (product?.data?.product_units_details?.length > 0) {
        product?.data?.product_units_details?.map((value, index) => {
          product_unit_details?.push({
            ...value,
            name: value?.name?.name,
            price_per_unit: 0,
            sale_price: value?.sale_price,
            wholesale_price: value?.wholesale_price,
            unit_quantity: 0,
            unit_delivered: 0,
          });
        });
      }
    } else {
      let selected_unit = "";
      let unit_ids = [];

      if (product?.data?.product_units_details?.length > 0) {
        product?.data?.product_units_details?.map((value, index) => {
          unit_ids?.push(value?._id);
        });
      }

      if (unit_ids?.includes(modaldata)) {
        selected_unit =
          product?.data?.product_units_details?.[unit_ids?.indexOf(modaldata)];
      }

      product_description = product?.data?._id;
      product_name = product?.data?.name;
      product_unit = modaldata;
      product_unit_name = selected_unit?.name?.name;
      product_conversion = selected_unit?.conversion;
      purchase_price = product?.data?.purchase_price;
      sale_price = product?.data?.sale_price;
      wholesale_price = product?.data?.wholesale_price;
      product_tax = product?.data?.tax;
    }

    data[index].description = product_description;
    data[index].name = product_name;
    data[index].unit = product_unit;
    data[index].unit_name = product_unit_name;
    data[index].quantity = "";
    data[index].conversion = product_conversion;
    data[index].unit_details_options = product_unit_details;
    data[index].purchase_price = purchase_price;
    data[index].sale_price = sale_price;
    data[index].wholesale_price = wholesale_price;
    data[index].tax = product_tax;
    data[index].tax_category = product_tax_category;
    if (product_tax_category) {
      fetchTaxOptions(product_tax_category, index);
    }

    setDetails(data);
    setModalData();
    setSelectedModalData();
    focus.current[`batch${index}`].current.focus();
  };

  const handlePurchasePriceSearch = async (e, index) => {
    let data = [...details];

    if (data[index].description) {
      const select = {
        api: "get-all-purchase-details",
        id: data[index].description,
      };

      const search = await select_id(select);
      if (search?.status) {
        let options = [];
        search?.data?.map((value, index) => {
          options?.push({
            value: JSON?.stringify(value),
            label: (
              <div>
                <div>
                  <UserCurrency />
                  &nbsp;{value?.purchase_price?.toFixed(3)}&nbsp;
                  {"(#PO-" + value?.purchase?.number + ")"}
                </div>
                <div>{formatDateDDMMYYYY(value?.purchase?.date)}</div>
              </div>
            ),
          });
        });

        data[index].purchase_options = options;
        setDetails(data);
      } else {
        toast?.error(search?.message);
      }
    }
  };

  const handlePurchasePriceSelect = (value, option, index) => {
    let data = [...details];

    if (value) {
      try {
        const priceData = JSON.parse(value);
        data[index].purchase_price = priceData?.price_per_unit;
        setDetails(data);

        handleTotal(priceData?.price_per_unit, index, "purchase_price");
      } catch (error) {
        console.error("Error parsing purchase price data:", error);
      }
    }
  };

  const handleSalePriceSearch = async (e, index) => {
    let data = [...details];

    if (data[index].description) {
      const select = {
        api: "get-all-purchase-details",
        id: data[index].description,
      };

      const search = await select_id(select);
      if (search?.status) {
        let options = [];
        search?.data?.map((value, index) => {
          options?.push({
            value: JSON?.stringify(value),
            label: (
              <div>
                <div>
                  <UserCurrency />
                  &nbsp;{value?.sale_price?.toFixed(3)}&nbsp;
                  {"(#SO-" + value?.sale?.number + ")"}
                </div>
                <div>{formatDateDDMMYYYY(value?.sale?.date)}</div>
              </div>
            ),
          });
        });

        data[index].sale_options = options;
        setDetails(data);
      } else {
        toast?.error(search?.message);
      }
    }
  };

  const handleSalePriceSelect = (value, option, index) => {
    let data = [...details];

    if (value) {
      try {
        const priceData = JSON.parse(value);
        data[index].sale_price = priceData?.sale_price;
        setDetails(data);

        if (data[index]?.unit_details_options?.length > 0) {
          data[index]?.unit_details_options?.map((v, i) => {
            data[index].unit_details_options[i].sale_price =
              parseFloat(priceData?.sale_price) / parseFloat(v?.conversion);
          });
        }

        setDetails(data);
      } catch (error) {
        console.error("Error parsing sale price data:", error);
      }
    }
  };

  const handleSalePrice = (value, index) => {
    if (value === "" || (!isNaN(value) && value >= 0)) {
      let data = [...details];
      const priceperunit = parseFloat(data[index]?.price_per_unit || 0);
      const salePrice = parseFloat(value || 0);
      const isComplete = value !== "" && !/\.$/.test(value);

      if (isComplete && priceperunit > 0 && salePrice < priceperunit) {
        data[index].sale_price_error = `Cannot be less than price/unit (${priceperunit.toFixed(3)})`;
      } else {
        data[index].sale_price_error = "";
      }

      data[index].sale_price = value;

      if (data[index]?.unit_details_options?.length > 0) {
        data[index].unit_details_options.forEach((v, i) => {
          if (value && !isNaN(value)) {
            data[index].unit_details_options[i].sale_price =
              parseFloat(value) / parseFloat(v?.conversion);
          }
        });
      }

      setDetails(data);
    }
  };

  const handleTotal = (e, index, key) => {
    let name = key ? key : e?.target?.name;
    let value = key && e ? e : !key && e?.target?.value ? e?.target?.value : "";

    if (name === "tax" && e && taxOptions) {
      const allTaxOptions = Object.values(taxOptions).flat();
      const matchedTax = allTaxOptions.find((t) => t.value === e);
      if (matchedTax) {
        value = {
          id: matchedTax.value,
          name: matchedTax.label,
          rate: matchedTax.rate,
        };
      }
    }

    if (value >= 0 || (name == "tax" && value)) {
      let data = [...details];

      console.log("adhsiknadsadsa", value, data[index]);

      let data_purchase_price = data[index]?.purchase_price
        ? data[index]?.purchase_price
        : 0;
      let data_discount_price = data[index]?.discount_price
        ? data[index]?.discount_price
        : 0;
      let data_discount_percentage = data[index]?.discount_percentage
        ? data[index]?.discount_percentage
        : 0;
      let data_quantity = data[index]?.quantity ? data[index]?.quantity : 0;
      let data_deliverd = data[index]?.delivered ? data[index]?.delivered : 0;
      let data_free = data[index]?.free ? data[index]?.free : 0;
      let data_tax = data[index]?.tax ? data[index]?.tax : null;
      let data_conversion = data[index].conversion ? data[index].conversion : 0;

      let item_purchase_price =
        name === "purchase_price" ? value : data_purchase_price;
      let quantity = name === "quantity" ? value : data_quantity;
      let delivered = name === "quantity" ? value : data_deliverd;
      let free = name === "free" ? value : data_free;
      let tax = name === "tax" ? value : data_tax;

      let invoice_purchase_price = parseFloat(item_purchase_price || 0);
      let invoice_discount_percentage = parseFloat(
        data_discount_percentage || 0,
      );

      let discount_price =
        (invoice_purchase_price * invoice_discount_percentage) / 100;

      let purchase_price =
        parseFloat(item_purchase_price) - parseFloat(discount_price);

      let tax_percentage = 0;
      if (typeof tax === "object" && tax !== null && tax?.rate != null) {
        tax_percentage = tax.rate;   // handles 0% correctly
      } else {
        tax_percentage = 0;
      }

      let tax_amount = tax_percentage
        ? parseFloat(purchase_price) *
        parseFloat(quantity ? quantity : 0) *
        (parseFloat(tax_percentage) / 100)
        : 0;

      let total =
        parseFloat(purchase_price) * parseFloat(quantity ? quantity : 0) +
        parseFloat(tax_amount);

      let price_per_unit =
        parseFloat(total ? total : 0) /
        (parseFloat(quantity ? quantity : 0) + parseFloat(free ? free : 0));

      let unit_details_options = [];
      if (data?.[index]?.unit_details_options?.length > 0) {
        data?.[index]?.unit_details_options?.map((v, i) => {
          let total_quantity =
            parseFloat(quantity || 0) + parseFloat(free || 0);

          unit_details_options?.push({
            ...v,
            price_per_unit: price_per_unit
              ? parseFloat(price_per_unit || 0) / parseFloat(v?.conversion || 0)
              : 0,
            unit_quantity: quantity
              ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
              : 0,
            unit_delivered: delivered
              ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
              : 0,
          });
        });
      }

      /* if (
        data_conversion > 0 &&
        parseFloat(quantity) + parseFloat(free) >= data_conversion
      ) {
        toast?.error(`Quantiy exceeding ${data[index].conversion}`);
      } else { */
      data[index][name] = value;
      data[index].discount_price = discount_price ? discount_price : "";
      data[index].unit_details_options = unit_details_options;
      data[index].delivered = parseFloat(quantity || 0) + parseFloat(free || 0);
      data[index].tax = tax ? tax : null;
      data[index].total = total ? total : 0;
      data[index].tax_amount = tax_amount ? tax_amount : "0.000";
      data[index].price_per_unit = price_per_unit ? price_per_unit : 0;

      let subtotal =
        data?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.total),
          0,
        ) -
        data?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.tax_amount),
          0,
        );

      let taxamount = data?.reduce(
        (acc, currentValue) =>
          parseFloat(acc) + parseFloat(currentValue?.tax_amount),
        0,
      );

      let grandtotal = data?.reduce(
        (acc, currentValue) =>
          parseFloat(acc) + parseFloat(currentValue?.total),
        0,
      );

      totals.subtotal = subtotal;
      totals.taxamount = taxamount;
      totals.total = grandtotal;

      setDetails(data);
      setTotals({ ...totals });
      /* } */
    }
  };

  const handleDiscountPrice = (e, index, key) => {
    let name = key ? key : e?.target?.name;
    let value = e?.target?.value ? e?.target?.value : "";

    if (name === "tax" && e && taxOptions) {
      const allTaxOptions = Object.values(taxOptions).flat();
      const matchedTax = allTaxOptions.find((t) => t.value === e);

      if (matchedTax) {
        value = {
          id: matchedTax.value,
          name: matchedTax.label,
          rate: matchedTax.rate,
        };
      }
    }

    if (value >= 0) {
      let data = [...details];

      if (
        parseFloat(value || 0) <=
        parseFloat(data[index]?.purchase_price || 0) ||
        name == "discount_percentage"
      ) {
        if (name == "discount_percentage" && parseFloat(value || 0) > 100) {
          toast?.error("Discount exceeding 100%");
        } else {
          let total_discount_price = 0;
          let total_discount_percentage = 0;

          if (parseFloat(value || 0) > 0) {
            const purchase_price = parseFloat(data[index]?.purchase_price || 0);
            const discount_value = parseFloat(value || 0);

            if (name == "discount_percentage") {
              total_discount_price = (purchase_price * discount_value) / 100;
              total_discount_percentage = discount_value;
            } else {
              total_discount_price = discount_value;
              total_discount_percentage =
                (discount_value / purchase_price) * 100;
            }
          }

          let data_purchase_price = data[index]?.purchase_price
            ? data[index]?.purchase_price
            : 0;
          let data_discount_price = total_discount_price
            ? total_discount_price
            : 0;
          let data_discount_percentage = total_discount_percentage
            ? total_discount_percentage
            : 0;
          let data_quantity = data[index]?.quantity ? data[index]?.quantity : 0;
          let data_deliverd = data[index]?.delivered
            ? data[index]?.delivered
            : 0;
          let data_free = data[index]?.free ? data[index]?.free : 0;
          let data_tax = data[index]?.tax ? data[index]?.tax : null;
          let data_conversion = data[index].conversion
            ? data[index].conversion
            : 0;

          let item_purchase_price =
            name === "purchase_price" ? value : data_purchase_price;
          let discount_price = data_discount_price ? data_discount_price : "";
          let discount_percentage = data_discount_percentage
            ? data_discount_percentage
            : "";
          let quantity = name === "quantity" ? value : data_quantity;
          let delivered = name === "quantity" ? value : data_deliverd;
          let free = name === "free" ? value : data_free;
          let tax = name === "tax" ? value : data_tax;

          let purchase_price =
            parseFloat(item_purchase_price || 0) -
            parseFloat(discount_price || 0);

          let tax_percentage = 0;
          if (typeof tax === "object" && tax?.rate) {
            tax_percentage = tax?.rate;
          } else if (typeof tax === "string") {
            tax_percentage = 5;
          } else {
            tax_percentage = tax;
          }

          let tax_amount = tax_percentage
            ? parseFloat(purchase_price) *
            parseFloat(quantity ? quantity : 0) *
            (parseFloat(tax_percentage) / 100)
            : 0;

          let total =
            parseFloat(purchase_price) * parseFloat(quantity ? quantity : 0) +
            parseFloat(tax_amount);

          let price_per_unit =
            parseFloat(total ? total : 0) /
            (parseFloat(quantity ? quantity : 0) + parseFloat(free ? free : 0));

          data[index].discount_price = discount_price;
          data[index].discount_percentage = value;
          data[index].delivered =
            parseFloat(quantity || 0) + parseFloat(free || 0);
          data[index].tax = tax ? tax : 0;
          data[index].total = total ? total : 0;
          data[index].tax_amount = tax_amount ? tax_amount : "0.000";
          data[index].price_per_unit = price_per_unit ? price_per_unit : 0;

          let subtotal =
            data?.reduce(
              (acc, currentValue) =>
                parseFloat(acc) + parseFloat(currentValue?.total),
              0,
            ) -
            data?.reduce(
              (acc, currentValue) =>
                parseFloat(acc) + parseFloat(currentValue?.tax_amount),
              0,
            );

          let taxamount = data?.reduce(
            (acc, currentValue) =>
              parseFloat(acc) + parseFloat(currentValue?.tax_amount),
            0,
          );

          let grandtotal =
            data?.reduce(
              (acc, currentValue) =>
                parseFloat(acc) + parseFloat(currentValue?.total),
              0,
            ) +
            parseFloat(totals?.delivery || 0) -
            parseFloat(totals?.discount || 0);

          totals.subtotal = subtotal;
          totals.taxamount = taxamount;
          totals.total = grandtotal;

          setDetails(data);
          setTotals({ ...totals });
        }
      } else {
        toast?.error("Exceeding purchase price");
      }
    } else {
      let data = [...details];

      let total_discount_price = 0;
      let total_discount_percentage = 0;

      let data_purchase_price = data[index]?.purchase_price
        ? data[index]?.purchase_price
        : 0;
      let data_discount_price = total_discount_price ? total_discount_price : 0;
      let data_discount_percentage = total_discount_percentage
        ? total_discount_percentage
        : 0;
      let data_quantity = data[index]?.quantity ? data[index]?.quantity : 0;
      let data_deliverd = data[index]?.delivered ? data[index]?.delivered : 0;
      let data_free = data[index]?.free ? data[index]?.free : 0;
      let data_tax = data[index]?.tax ? data[index]?.tax : 0;
      let data_conversion = data[index].conversion ? data[index].conversion : 0;

      let item_purchase_price =
        name === "purchase_price" ? value : data_purchase_price;
      let discount_price = data_discount_price ? data_discount_price : "";
      let discount_percentage = data_discount_percentage
        ? data_discount_percentage
        : "";
      let quantity = name === "quantity" ? value : data_quantity;
      let delivered = name === "quantity" ? value : data_deliverd;
      let free = name === "free" ? value : data_free;
      let tax = name === "tax" ? value : data_tax;

      let purchase_price =
        parseFloat(item_purchase_price || 0) - parseFloat(discount_price || 0);

      let tax_amount = tax
        ? parseFloat(purchase_price) *
        parseFloat(quantity ? quantity : 0) *
        (parseFloat(tax) / 100)
        : 0;

      let total =
        parseFloat(purchase_price) * parseFloat(quantity ? quantity : 0) +
        parseFloat(tax_amount);

      let price_per_unit =
        parseFloat(total ? total : 0) /
        (parseFloat(quantity ? quantity : 0) + parseFloat(free ? free : 0));

      data[index].discount_price = discount_price;
      data[index].discount_percentage = value;
      data[index].delivered = parseFloat(quantity || 0) + parseFloat(free || 0);
      data[index].tax = tax ? tax : 0;
      data[index].total = total ? total : 0;
      data[index].tax_amount = tax_amount ? tax_amount : "0.000";
      data[index].price_per_unit = price_per_unit ? price_per_unit : 0;

      let subtotal =
        data?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.total),
          0,
        ) -
        data?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.tax_amount),
          0,
        );

      let taxamount = data?.reduce(
        (acc, currentValue) =>
          parseFloat(acc) + parseFloat(currentValue?.tax_amount),
        0,
      );

      let grandtotal =
        data?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.total),
          0,
        ) +
        parseFloat(totals?.delivery || 0) -
        parseFloat(totals?.discount || 0);

      totals.subtotal = subtotal;
      totals.taxamount = taxamount;
      totals.total = grandtotal;

      setDetails(data);
      setTotals({ ...totals });
    }
  };

  const handleChange = (e, index, key) => {
    let data = [...details];

    data[index][e?.target?.name] = e?.target?.value;
    setDetails(data);
  };

  const handleWholeSalePrice = (e, index) => {
    const value = e?.target?.value;

    if (e?.target?.value >= 0) {
      let data = [...details];
      const purchasePrice = parseFloat(data[index]?.purchase_price || 0);
      const wholesalePrice = parseFloat(value || 0);

      if (value !== "" && purchasePrice > 0 && wholesalePrice < purchasePrice) {
        toast.error(
          `Wholesale price (${wholesalePrice.toFixed(3)}) cannot be less than purchase price (${purchasePrice.toFixed(3)})`,
          {
            duration: 3000,
          },
        );
      }

      data[index].wholesale_price = e?.target?.value;

      if (data[index]?.unit_details_options?.length > 0) {
        data[index]?.unit_details_options?.map((v, i) => {
          data[index].unit_details_options[i].wholesale_price =
            parseFloat(e?.target?.value) / parseFloat(v?.conversion);
        });
      }

      setDetails(data);
    }
  };

  const handleUnitsTotal = (e, index, i) => {
    let data = [...details];

    let name = e?.target?.name;
    let value = e?.target?.value;

    if (name) {
      if (value >= 0) {
        data[index].unit_details_options[i][name] = value;
        setDetails(data);
      }
    }
  };

  const handleUnitPurchasePrice = (e, index, i) => {
    let data = [...details];

    let name = e?.target?.name;
    let value = e?.target?.value;

    if (name) {
      if (value >= 0) {
        data[index].unit_details_options[i].price_per_unit = value;
        setDetails(data);
      }
    }
  };

  const handleUnitSalePrice = (e, index, i) => {
    let data = [...details];

    let name = e?.target?.name;
    let value = e?.target?.value;

    if (name) {
      if (value >= 0) {
        data[index].unit_details_options[i].sale_price = value;
        setDetails(data);
      }
    }
  };

  const handleWnitWholesalePrice = (e, index, i) => {
    let data = [...details];

    let name = e?.target?.name;
    let value = e?.target?.value;

    if (name) {
      if (value >= 0) {
        data[index].unit_details_options[i].wholesale_price = value;
        setDetails(data);
      }
    }
  };

  const handleDate = (e, index, name) => {
    let data = [...details];
    data[index][name] = e?.$d;

    setDetails(data);
  };

  const handleDelivered = (e, index) => {
    let data = [...details];

    let data_delivered = e?.target?.value ? parseFloat(e?.target?.value) : 0;

    let data_quantity = data[index]?.quantity
      ? parseFloat(data[index]?.quantity)
      : 0;
    let data_free = data[index]?.free ? parseFloat(data[index]?.free) : 0;
    let total_quantity =
      parseFloat(data_quantity || 0) + parseFloat(data_free || 0);

    if (data_delivered >= 0) {
      if (data_delivered <= total_quantity) {
        let unit_details_options = [];
        if (data?.[index]?.unit_details_options?.length > 0) {
          data?.[index]?.unit_details_options?.map((v, i) => {
            unit_details_options?.push({
              ...v,
              unit_delivered: data_delivered
                ? parseFloat(data_delivered) * parseFloat(v?.conversion)
                : 0,
            });
          });
        }

        data[index][e?.target?.name] = e?.target?.value;
        data[index].unit_details_options = unit_details_options;

        setDetails(data);
      } else {
        toast?.error(`Quantity only ${total_quantity}`);
      }
    }
  };

  const handleRemove = (index) => {
    let data = [...details];

    let name = "quantity";
    let value = 0;

    if (value >= 0) {
      let data_purchase_price = data[index]?.purchase_price
        ? data[index]?.purchase_price
        : 0;
      let data_quantity = data[index]?.quantity ? data[index]?.quantity : 0;
      let data_deliverd = data[index]?.delivered ? data[index]?.delivered : 0;
      let data_free = data[index]?.free ? data[index]?.free : 0;
      let data_tax = data[index]?.tax ? data[index]?.tax : 0;
      let data_conversion = data[index].conversion ? data[index].conversion : 0;

      let purchase_price =
        name === "purchase_price" ? value : data_purchase_price;
      let quantity = name === "quantity" ? value : data_quantity;
      let delivered = name === "quantity" ? value : data_deliverd;
      let free = name === "free" ? value : data_free;
      let tax = name === "tax" ? value : data_tax;

      let tax_amount = tax
        ? parseFloat(purchase_price) *
        parseFloat(quantity ? quantity : 0) *
        (parseFloat(tax) / 100)
        : 0;

      let total =
        parseFloat(purchase_price) * parseFloat(quantity ? quantity : 0) +
        parseFloat(tax_amount);

      let price_per_unit =
        parseFloat(total ? total : 0) /
        (parseFloat(quantity ? quantity : 0) + parseFloat(free ? free : 0));

      let unit_details_options = [];
      if (data?.[index]?.unit_details_options?.length > 0) {
        data?.[index]?.unit_details_options?.map((v, i) => {
          let total_quantity =
            parseFloat(quantity || 0) + parseFloat(free || 0);

          unit_details_options?.push({
            ...v,
            price_per_unit: price_per_unit
              ? parseFloat(price_per_unit || 0) / parseFloat(v?.conversion || 0)
              : 0,
            unit_quantity: quantity
              ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
              : 0,
            unit_delivered: delivered
              ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
              : 0,
          });
        });
      }

      if (
        data_conversion > 0 &&
        parseFloat(quantity) + parseFloat(free) >= data_conversion
      ) {
        toast?.error(`Quantiy exceeding ${data[index].conversion}`);
      } else {
        data[index][name] = value;
        data[index].unit_details_options = unit_details_options;
        data[index].delivered =
          parseFloat(quantity || 0) + parseFloat(free || 0);
        data[index].tax = tax ? tax : 0;
        data[index].total = total ? total : 0;
        data[index].tax_amount = tax_amount ? tax_amount : "0.000";
        data[index].price_per_unit = price_per_unit ? price_per_unit : 0;

        let subtotal =
          data?.reduce(
            (acc, currentValue) =>
              parseFloat(acc) + parseFloat(currentValue?.total),
            0,
          ) -
          data?.reduce(
            (acc, currentValue) =>
              parseFloat(acc) + parseFloat(currentValue?.tax_amount),
            0,
          );

        let taxamount = data?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.tax_amount),
          0,
        );

        let grandtotal = data?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.total),
          0,
        );

        totals.subtotal = subtotal;
        totals.taxamount = taxamount;
        /* 
        totals.delivery_status = 0;
        totals.delivery_date = "";
        totals.payment_status = 0;
        totals.payment_types = null;
        totals.payments = [{
          id: `temp-cash-${Date.now()}`,
          name: "Cash",
          amount: ""
        }]; */
        totals.total = grandtotal;

        data?.splice(index, 1);
        setDetails(data);
        setTotals({ ...totals });
      }
    }
  };

  // const handleAdd = () => {
  //   setDetails((prevDetails) => [
  //     ...prevDetails,
  //     {
  //       id: "",
  //       description: null,
  //       name: "",
  //       unit: "",
  //       unit_name: "",
  //       unit_details_options: null,
  //       quantity: "",
  //       purchase: "",
  //       purchase_price: "",
  //       purchase_options: null,
  //       delivered: "",
  //       tax: 0,
  //       free: "",
  //       barcode: "",
  //       price_per_unit: "",
  //       sale_price: "",
  //       sale_options: null,
  //       expiry_date: "",
  //       tax_amount: "0.000",
  //       total: 0,
  //     },
  //   ]);

  //   setTimeout(() => {
  //     focus.current[`description${details?.length}`].current.focus();
  //   }, 100);
  // };

  const handleAdd = () => {
  const newIndex = details.length;

  setDetails((prev) => [
    ...prev,
    {
      id: "",
      description: null,
      name: "",
      unit: "",
      unit_name: "",
      unit_details_options: null,
      quantity: "",
      purchase: "",
      purchase_price: "",
      purchase_options: null,
      delivered: "",
      tax: 0,
      free: "",
      barcode: "",
      price_per_unit: "",
      sale_price: "",
      sale_options: null,
      expiry_date: "",
      tax_amount: "0.000",
      total: 0,
    },
  ]);

  setTimeout(() => {
    focus.current[`description${newIndex}`]?.current?.focus();
  }, 100);
};
  const handleDelivery = (e) => {
    if (e?.target?.value >= 0) {
      let total_amount = parseFloat(
        details?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.total),
          0,
        ),
      );

      let total =
        parseFloat(total_amount ? total_amount : 0) +
        parseFloat(e?.target?.value ? e?.target?.value : 0) -
        parseFloat(totals?.discount ? totals?.discount : 0);

      totals.delivery = e?.target?.value;
      totals.total = total;

      setTotals({ ...totals });
    }
  };

  const handleDiscount = (e) => {
    if (e?.target?.value >= 0) {
      let total_amount = parseFloat(
        details?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.total),
          0,
        ),
      );

      let total =
        parseFloat(total_amount ? total_amount : 0) +
        parseFloat(totals?.delivery ? totals?.delivery : 0) -
        parseFloat(e?.target?.value ? e?.target?.value : 0);

      if (e?.target?.value <= total_amount) {
        totals.discount = e?.target?.value;
        totals.total = total;
      } else {
        toast?.error(`Total amount ${total_amount}`);
      }

      setTotals({ ...totals });
    }
  };

  const handleDeliveryStatus = (e) => {
    totals.delivery_status = e;

    if (!e) {
      totals.delivery_date = "";
    } else if (e == 1) {
      totals.delivery_date = "";
    }

    setTotals({ ...totals });
  };

  const handleDeliveryDate = (e) => {
    totals.delivery_date = e?.$d;
    setTotals({ ...totals });
  };

  const handlePaymentStatus = (e) => {
    totals.payment_status = e;

    if (!e) {
      totals.payment_types = null;
    }
    setTotals({ ...totals });
  };

  /* const handlePaymentTypes = (e) => {
    totals?.payment_types?.map((v, i) => {
      if (!e?.includes(v)) {
        totals.payments[v] = "";
      }
    });
  
    totals.payment_types = e;
  
    setTotals({ ...totals });
  }; */

  const handlePaymentTypes = (e) => {
    const updatedPaymentTypes = e || [];

    let updatedPayments = [...(totals.payments || [])];

    updatedPayments = updatedPayments.filter((payment) =>
      updatedPaymentTypes.includes(payment.name),
    );

    updatedPaymentTypes?.forEach((type) => {
      if (!updatedPayments.some((p) => p.name === type)) {
        updatedPayments.push({
          id: `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
          name: type,
          amount: "",
        });
      }
    });

    totals.payment_types = updatedPaymentTypes;
    totals.payments = updatedPayments;

    setTotals({ ...totals });
  };

  /* const handlePayments = (e) => {
    let name = e?.target?.name;
    let value = e?.target?.value ? e?.target?.value : "";
  
    if (e?.target?.value >= 0) {
      let data_Cash = totals?.payments?.Cash?.amount
        ? totals?.payments?.Cash?.amount
        : 0;
      let data_Cheque = totals?.payments?.Cheque?.amount
        ? totals?.payments?.Cheque?.amount
        : 0;
      let data_Debitcard = totals?.payments?.["Debit card"]?.amount
        ? totals?.payments?.["Debit card"]?.amount
        : 0;
      let data_Creditcard = totals?.payments?.["Credit card"]?.amount
        ? totals?.payments?.["Credit card"]?.amount
        : 0;
      let data_Banktransfer = totals?.payments?.["Bank transfer"]?.amount
        ? totals?.payments?.["Bank transfer"]?.amount
        : 0;
      let data_Onlinepayment = totals?.payments?.["Online payment"]?.amount
        ? totals?.payments?.["Online payment"]?.amount
        : 0;
  
      let Cash = name === "Cash" ? value : data_Cash;
      let Cheque = name === "Cheque" ? value : data_Cheque;
      let Debitcard = name === "Debit card" ? value : data_Debitcard;
      let Creditcard = name === "Credit card" ? value : data_Creditcard;
      let Banktransfer = name === "Bank transfer" ? value : data_Banktransfer;
      let Onlinepayment =
        name === "Online payment" ? value : data_Onlinepayment;
  
      let total =
        parseFloat(Cash) +
        parseFloat(Cheque) +
        parseFloat(Debitcard) +
        parseFloat(Creditcard) +
        parseFloat(Banktransfer) +
        parseFloat(Onlinepayment);
  
      let payment_total = total ? parseFloat(total) : 0;
      let grand_total = totals?.total ? parseFloat(totals?.total) : 0;
  
      if (
        parseFloat(payment_total?.toFixed(3) || 0) <=
        parseFloat(grand_total?.toFixed(3) || 0)
      ) {
        totals.payments[name] = { ...totals.payments[name], amount: value };
        setTotals({ ...totals });
      } else {
        let previous_total =
          parseFloat(data_Cash) +
          parseFloat(data_Cheque) +
          parseFloat(data_Debitcard) +
          parseFloat(data_Creditcard) +
          parseFloat(data_Banktransfer) +
          parseFloat(data_Onlinepayment);
  
        totals.payments[name] = { ...totals.payments[name], amount: "" };
        setTotals({ ...totals });
  
        let previous_remaining_amount =
          parseFloat(grand_total) - parseFloat(previous_total);
  
        toast?.error(`Pending only ${previous_remaining_amount?.toFixed?.(3)}`);
      }
    }
  }; */

  const handlePayments = (e, paymentId) => {
    let name = e?.target?.name.split("_")[0];
    let value = e?.target?.value ? e?.target?.value : "";

    if (e?.target?.value >= 0) {
      let updatedPayments = [...totals.payments];
      const index = updatedPayments.findIndex((p) => p.id === paymentId);

      if (index !== -1) {
        let currentTotal = updatedPayments.reduce(
          (sum, p) => sum + parseFloat(p.amount || 0),
          0,
        );
        let newPaymentAmount = parseFloat(value || 0);
        let oldPaymentAmount = parseFloat(updatedPayments[index].amount || 0);
        let newTotal = currentTotal - oldPaymentAmount + newPaymentAmount;
        let grandTotal = totals?.total ? parseFloat(totals?.total) : 0;

        if (newTotal <= grandTotal.toFixed(3)) {
          updatedPayments[index].amount = value;
          totals.payments = updatedPayments;
          setTotals({ ...totals });
        } else {
          let remaining = grandTotal - (currentTotal - oldPaymentAmount);
          toast?.error(`Remaining amount: ${remaining?.toFixed(3)}`);
        }
      }
    }
  };

  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const dateFormatList = ["DD/MM/YYYY", "DD-MM-YYYY"];

  const handleAddPayment = (type) => {
    let updatedPayments = [...totals.payments];

    const paymentsOfType = updatedPayments.filter((p) => p.name === type);
    const newId = `temp-${type}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

    updatedPayments.push({
      id: newId,
      name: type,
      amount: "",
    });

    totals.payments = updatedPayments;
    setTotals({ ...totals });

    setTimeout(() => {
      if (focus.current[newId]?.current) {
        focus.current[newId].current.focus();
      }
    }, 100);
  };

  const groupedPayments = totals?.payments.reduce((groups, payment) => {
    if (!groups[payment.name]) {
      groups[payment.name] = [];
    }
    groups[payment.name].push(payment);
    return groups;
  }, {});

  const handleRemovePayment = (paymentId) => {
    let updatedPayments = totals.payments.filter((p) => p.id !== paymentId);

    const paymentTypes = new Set(updatedPayments.map((p) => p.name));
    let updatedPaymentTypes = totals.payment_types?.filter((type) =>
      paymentTypes.has(type),
    );

    totals.payments = updatedPayments;
    totals.payment_types = updatedPaymentTypes;

    setTotals({ ...totals });
  };

  return (
    <div className="overflow-x-auto">
      <Modalcomponent
        open={open}
        setOpen={setOpen}
        modalData={modalData}
        setModalData={setModalData}
        selectedModalData={selectedModalData}
        setSelectedModalData={setSelectedModalData}
        handleModal={handleModal}
      />
      <Modal
        open={productModalOpen}
        onCancel={handleProductModalClose}
        footer={null}
        width={800}
        className="select-add-modal"
        styles={{
          body: {
            padding: 0,
            margin: 0,
          },
          content: {
            padding: 0,
          },
        }}
      >
        <div className="modal-form-wrapper">
          <ProductsForm isModal={true} onClose={handleProductModalClose} />
        </div>
      </Modal>
      <div className="w-[100%]">
        <table className="">
          <thead>
            <tr>
              <td className="border p-4 text-black">S.NO</td>
              <td className="border p-4 text-black">DESCRIPTION</td>
              <td className="border p-4 text-black">UNIT</td>
              <td className="border p-4 text-black">QUANTITY</td>
              <td className="border p-4 text-black">FOC</td>
              <td className="border p-4 text-black">PURCHASE&nbsp;PRICE</td>
              {authorizeMail && <td className="border p-4 text-black">%&nbsp;of&nbsp;Margin</td>}
              <td className="border p-4 text-black">DISCOUNT</td>
              <td className="border p-4 text-black">TAX&nbsp;[VAT]</td>
              <td className="border p-4 text-black">TOTAL</td>
              <td className="border p-4 text-black">DELETE</td>
            </tr>
          </thead>
          <tbody>
            {details?.map((value, index) => {
              focus.current[`description${index}`] = createRef();
              focus.current[`purchase_price${index}`] = createRef();
              focus.current[`quantity${index}`] = createRef();
              focus.current[`sale_price${index}`] = createRef();
              focus.current[`wholesale_price${index}`] = createRef();
              focus.current[`batch${index}`] = createRef();
              return (
                <React.Fragment key={index}>
                  <tr>
                    <td className="border p-4 text-center align-baseline text-gray-700">
                      {index + 1}
                    </td>
                    <td className="border p-4 align-baseline">
                      <div className="pb-4">
                        {value?.description ? (
                          <div className="w-[300px]">{value?.name}</div>
                        ) : (
                          <div className="flex min-w-[300px] gap-2">
                            <div className="flex-grow">
                              <Select
                                className="w-full text-regular"
                                name="description"
                                ref={focus.current[`description${index}`]}
                                placeholder="Description"
                                allowClear={true}
                                showSearch={true}
                                filterOption={false}
                                value={value?.description}
                                options={value?.options}
                                onSearch={(e) => handleSearch(e, index)}
                                // onClick={(e) => handleSearch("", index)}
                                onFocus={(e) => handleSearch("", index)}
                                // onChange={(e) => handleDescription(e, index)}
                                onChange={(value, option) =>
                                  handleDescription(value, index, option)
                                }
                                autoComplete="off"
                              />
                            </div>
                            <div>
                              <PlusButton
                                onClick={() => handleOpenProductModal(index)}
                              />
                            </div>
                          </div>
                        )}
                        <Error id={`description${index}`} />
                      </div>
                      <div className="border-t pt-2 align-top">
                        <div className="pb-2 text-gray-700">Batch</div>
                        <Input
                          type="text"
                          className="w-full text-regular"
                          name="batch"
                          placeholder="Batch Number"
                          ref={focus.current[`batch${index}`]}
                          value={value?.batch}
                          onChange={(e) => handleChange(e, index)}
                          onKeyDown={handleOnKeyDown}
                          autoComplete="off"
                        />

                        <div className="pb-2 pt-2 text-gray-700">EXPIRY</div>
                        {/*  <DatePicker
                          format={dateFormatList}
                          allowClear
                          inputReadOnly={false}
                          type="number"
                          className="w-full text-regular"
                          name="expiry_date"
                          placeholder="Expiry"
                          value={
                            value?.expiry_date && dayjs(value?.expiry_date)
                          }
                          onChange={(e) => handleDate(e, index, "expiry_date")}
                          autoComplete="off"
                          onKeyDown={handleDateKeyDown}
                          onInput={handleDateInputDebounced}
                          onPaste={blockPaste}
                          onBlur={(e) =>
                            handleDateBlur(e, (date) => handleDate({ $d: date }, index, "expiry_date"))
                          }
                        /> */}
                        <DatePicker
                          format={dateFormatList}
                          allowClear
                          inputReadOnly={false}
                          type="number"
                          className="w-full text-regular"
                          name="expiry_date"
                          placeholder="Expiry"
                          value={
                            value?.expiry_date && dayjs(value?.expiry_date)
                          }
                          onChange={(e) => handleDate(e, index, "expiry_date")}
                          autoComplete="off"
                          onKeyDown={handleDateKeyDown}
                          onInput={handleDateInput}
                          onPaste={blockPaste}
                          onBlur={(e) =>
                            handleDateBlur(e, (date) => {
                              handleDate({ $d: date }, index, "expiry_date");
                            })
                          }
                        />
                        <div className="pb-2 pt-2 text-gray-700">
                          BARCODE (BATCH)
                        </div>
                        <Input
                          type="text"
                          className="w-full text-regular"
                          name="barcode"
                          placeholder="Inventory Batch Wise Barcode"
                          value={value?.barcode}
                          onChange={(e) => handleChange(e, index)}
                          onKeyDown={handleOnKeyDown}
                          autoComplete="off"
                        />
                      </div>
                    </td>
                    <td className="border p-4 text-center align-baseline">
                      <div>{value?.unit_name}</div>
                    </td>
                    <td className="border p-4 text-center align-baseline">
                      <div>
                        <Input
                          type="number"
                          className="w-[70px] text-regular"
                          name="quantity"
                          ref={focus.current[`quantity${index}`]}
                          placeholder="Quantity"
                          value={value?.quantity}
                          onChange={(e) => handleTotal(e, index)}
                          autoComplete="off"
                          onKeyDown={(e) => {
                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => {
                            e.target.blur();
                          }}
                        />
                        <div className="">
                          <Error id={`quantity${index}`} />
                        </div>
                      </div>
                    </td>
                    <td className="border p-4 text-center align-baseline">
                      <Input
                        type="number"
                        className="w-[70px] text-regular"
                        name="free"
                        placeholder="Free"
                        value={value?.free}
                        onChange={(e) => handleTotal(e, index)}
                        autoComplete="off"
                        onKeyDown={(e) => {
                          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(e) => {
                          e.target.blur();
                        }}
                      />
                    </td>
                    <td className="border p-4 text-center align-baseline">
                      <div className="pb-4">
                        <div>
                          <AutoComplete
                            className=" text-regular w-full"
                            name="purchase_price"
                            ref={focus.current[`purchase_price${index}`]}
                            placeholder={`Purchase price`}
                            allowClear={true}
                            showSearch={true}
                            filterOption={false}
                            options={value?.purchase_options}
                            value={value?.purchase_price}
                            onFocus={(e) =>
                              handlePurchasePriceSearch("", index)
                            }
                            onSelect={(value, option) =>
                              handlePurchasePriceSelect(value, option, index)
                            }
                            onChange={(e) =>
                              handleTotal(e, index, "purchase_price")
                            }
                            autoComplete="off"
                          />
                          <Error
                            className="pt-0.5 text-xs text-red-500 text-left"
                            id={`purchase_price${index}`}
                          />
                        </div>
                      </div>
                      <div className="border-t pt-2 align-top text-left">
                        <div>
                          <div className="pb-2 text-gray-700 uppercase">
                            PRICE/UNIT
                          </div>
                          <div className="pb-2">
                            {value?.price_per_unit
                              ? parseFloat(value?.price_per_unit)?.toFixed(3)
                              : "0.000"}
                          </div>
                        </div>
                        {value?.unit_details_options?.length > 0 ? (
                          <div>
                            {value?.unit_details_options?.map((v, i) => {
                              return (
                                <div key={i}>
                                  <div className="pb-2 text-gray-700 uppercase">
                                    {v?.name}({v?.conversion})
                                  </div>
                                  <div className="pb-2">
                                    {v?.price_per_unit
                                      ? parseFloat?.(
                                        v?.price_per_unit,
                                      )?.toFixed(3)
                                      : "0.000"}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          ""
                        )}
                        <div>
                          <div>
                            <div className="pb-2 text-gray-700 uppercase">
                              SALE/RETAIL&nbsp;PRICE
                              <Required />
                            </div>
                            <AutoComplete
                              className="w-full text-regular"
                              name="sale_price"
                              ref={focus.current[`sale_price${index}`]}
                              placeholder="Sale price"
                              allowClear={true}
                              showSearch={true}
                              filterOption={false}
                              options={value?.sale_options}
                              value={value?.sale_price}
                              onFocus={(e) => handleSalePriceSearch("", index)}
                              onSelect={(value, option) =>
                                handleSalePriceSelect(value, option, index)
                              }
                              onChange={(value) =>
                                handleSalePrice(value, index)
                              }
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  e.key === "ArrowUp" ||
                                  e.key === "ArrowDown"
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              onWheel={(e) => {
                                e.target.blur();
                              }}
                            />
                            <Error id={`sale_price${index}`} />
                          </div>
                        </div>
                        {value?.unit_details_options?.length > 0 ? (
                          <>
                            {value?.unit_details_options?.map((v, i) => {
                              focus.current[`sale_price${index}${i}`] =
                                createRef();
                              return (
                                <div key={i}>
                                  <div className="text-gray-700 uppercase">
                                    {v?.name}({v?.conversion})
                                  </div>
                                  <div className="pt-2">
                                    <div className="pt-2">
                                      {v?.sale_price
                                        ? v?.sale_price?.toFixed(3)
                                        : "0.000"}
                                    </div>
                                    <Error id={`sale_price${index}${i}`} />
                                  </div>
                                </div>
                              );
                            })}
                          </>
                        ) : (
                          ""
                        )}
                        <div>
                          <div className="pt-1 pb-2 text-gray-700 uppercase">
                            WHOLESALE&nbsp;PRICE
                          </div>
                          <Input
                            type="number"
                            className="w-full text-regular"
                            name="wholesale_price"
                            ref={focus.current[`wholesale_price${index}`]}
                            placeholder="Wholesale price"
                            value={value?.wholesale_price}
                            onChange={(e) => handleWholeSalePrice(e, index)}
                            autoComplete="off"
                            onKeyDown={(e) => {
                              if (
                                e.key === "ArrowUp" ||
                                e.key === "ArrowDown"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onWheel={(e) => {
                              e.target.blur();
                            }}
                          />
                          <Error id={`wholesale_price${index}`} />
                        </div>
                        {value?.unit_details_options?.length > 0 ? (
                          <>
                            {value?.unit_details_options?.map((v, i) => {
                              focus.current[`wholesale_price${index}${i}`] =
                                createRef();
                              return (
                                <div key={i}>
                                  <div className="text-gray-700 uppercase">
                                    {v?.name}({v?.conversion})
                                  </div>
                                  <div className="pt-2">
                                    <div className="pt-2">
                                      {v?.wholesale_price
                                        ? v?.wholesale_price?.toFixed(3)
                                        : "0.000"}
                                    </div>
                                    <Error id={`wholesale_price${index}${i}`} />
                                  </div>
                                </div>
                              );
                            })}
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </td>

                    {authorizeMail && <td className="border p-4 text-center align-baseline">
                      <div className="pb-4">
                        {(() => {
                          const sp = Number(value?.sale_price);
                          const cp = Number(value?.price_per_unit);

                          if (!sp || sp <= 0 || !cp || cp < 0) return "0.000";

                          const margin = ((sp - cp) / sp) * 100;

                          return margin.toFixed(3);
                        })()}
                      </div>
                    </td>}

                    <td className="border p-4 text-center align-baseline">
                      <div className="pb-4">
                        <Input
                          type="text"
                          className="w-[100px] text-regular"
                          name="discount_percentage"
                          placeholder="Discount %"
                          value={value?.discount_percentage}
                          suffix="%"
                          onChange={(e) =>
                            handleDiscountPrice(e, index, "discount_percentage")
                          }
                          autoComplete="off"
                        />
                      </div>
                      <div className="border-t pt-2 align-top text-left">
                        <div className="pb-2">Disc</div>
                        <div className="">
                          <Input
                            type="number"
                            className="w-[100px] text-regular"
                            name="discount_price"
                            placeholder="Discount price"
                            value={value?.discount_price}
                            onChange={(e) =>
                              handleDiscountPrice(e, index, "discount_price")
                            }
                            autoComplete="off"
                            onKeyDown={(e) => {
                              if (
                                e.key === "ArrowUp" ||
                                e.key === "ArrowDown"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onWheel={(e) => {
                              e.target.blur();
                            }}
                          />
                        </div>
                      </div>
                    </td>

                    <td className="border p-4 text-left align-baseline">
                      {/*  <div className="pb-4">
                        <Select
                          className="w-[80px] text-regular"
                          name="tax"
                          placeholder="Tax"
                          options={taxes}
                          value={value?.tax}
                          onChange={(e) => handleTotal(e, index, "tax")}
                        />
                      </div> */}
                      <div className="pb-4">
                        <Select
                          className="w-full text-regular"
                          name="tax"
                          ref={focus.current[`tax${index}`]}
                          placeholder="Tax"
                          allowClear={true}
                          showSearch={true}
                          filterOption={false}
                          options={getTaxOptionsForRow(index)}
                          value={
                            value?.tax?.name
                              ? value?.tax?.name
                              : value?.tax_details?.name
                                ? value?.tax_details?.name
                                : value?.tax
                          }
                          onSearch={(e) => handleTaxSearch(e, index)}
                          onFocus={() => handleTaxSearch("", index)}
                          onClick={() => handleTaxSearch("", index)}
                          onChange={(e) => handleTotal(e, index, "tax")}
                          autoComplete="off"
                        />
                      </div>
                      <div className="border-t pt-2 align-top text-left w-[80px] ">
                        <div className="pb-2 text-gray-700 uppercase">
                          TAX&nbsp;[VAT]
                        </div>
                        <div>
                          <div className="w-[80px] border border-gray-200 p-1 rounded-md">
                            {value?.tax_amount
                              ? parseFloat(value?.tax_amount)?.toFixed(3)
                              : "0.000"}
                          </div>
                        </div>
                      </div>
                    </td>

                    <td className="border p-4 text-center text-gray-700 align-baseline">
                      {value?.total
                        ? parseFloat?.(value?.total)?.toFixed(3)
                        : "0.000"}
                    </td>
                    <td className="border p-4 text-center align-baseline">
                      {value?.id ? (
                        <button
                          type="button"
                          className="text-lg text-red-500 cursor-pointer hover:text-red-800"
                          /*  disabled={true} */
                          onClick={() => handleRemove(index)}
                        >
                          <DeleteOutlined />
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="text-lg text-red-500 cursor-pointer hover:text-red-800"
                          onClick={() => handleRemove(index)}
                        >
                          <DeleteOutlined />
                        </button>
                      )}
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td className="border p-4" rowSpan={2} colSpan={7}></td>
              <td className="border p-4" rowSpan={2} colSpan={3}>
                <div className="text-center">
                  <AddButton
                    className={"form-save-button w-full h-full text-center"}
                    onClick={handleAdd}
                  />
                </div>
              </td>
            </tr>
            <tr></tr>
            <tr>
              <td className="border p-4" colSpan={7}></td>
              <td className="border p-4 text-gray-700">SUBTOTAL</td>
              <td className="border p-4" colSpan={2}>
                {totals?.subtotal > 0 ? totals?.subtotal?.toFixed(3) : "0.000"}
              </td>
            </tr>
            <tr>
              <td className="border p-4" colSpan={7}></td>
              <td className="border p-4 text-gray-700">TAX&nbsp;[VAT]</td>
              <td className="border p-4" colSpan={2}>
                {totals?.taxamount > 0
                  ? totals?.taxamount?.toFixed(3)
                  : "0.000"}
              </td>
            </tr>
            <tr>
              <td className="border p-4" colSpan={7}></td>
              <td className="border p-4 text-gray-700">DISCOUNT&nbsp;</td>
              <td className="border p-4" colSpan={2}>
                <Input
                  type="number"
                  className="w-full"
                  placeholder="Discount amount"
                  name="discount"
                  value={totals?.discount}
                  autoComplete="off"
                  onChange={handleDiscount}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => {
                    e.target.blur();
                  }}
                />
              </td>
            </tr>
            <tr>
              <td className="border p-4" colSpan={7}></td>
              <td className="border p-4 text-gray-700">
                DELIVERY&nbsp;CHARGES
              </td>
              <td className="border p-4" colSpan={2}>
                <Input
                  type="number"
                  className="w-full"
                  placeholder="Delivery charges"
                  name="delivery"
                  value={totals?.delivery}
                  autoComplete="off"
                  onChange={handleDelivery}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => {
                    e.target.blur();
                  }}
                />
              </td>
            </tr>
            <tr>
              <td className="border p-4" colSpan={7}></td>
              <td className="border p-4 text-gray-700">DELIVERY&nbsp;STATUS</td>
              <td className="border p-4" colSpan={2}>
                <div>
                  <div>
                    <Select
                      className="w-full"
                      name="tax"
                      placeholder="Delivery status"
                      value={totals?.delivery_status}
                      options={[
                        {
                          value: 0,
                          label: "Pending",
                        },
                        {
                          value: 1,
                          label: "Partial",
                        },
                        {
                          value: 2,
                          label: "Delivered",
                        },
                      ]}
                      onChange={handleDeliveryStatus}
                    />
                  </div>
                  {totals?.delivery_status == 2 && (
                    <div className="pt-4">
                      <DatePicker
                        format={dateFormatList}
                        type="number"
                        name="delivery_date"
                        ref={focus.current[`delivery_date`]}
                        className="w-full"
                        placeholder="Delivered date"
                        value={
                          totals?.delivery_date && dayjs(totals?.delivery_date)
                        }
                        onChange={handleDeliveryDate}
                        autoComplete="off"
                        onKeyDown={handleDateKeyDown}
                        onInput={handleDateInput}
                        onPaste={blockPaste}
                        onBlur={(e) =>
                          handleDateBlur(e, (date) =>
                            handleDeliveryDate({ $d: date }),
                          )
                        }
                      />
                      <Error id={`delivery_date`} />
                    </div>
                  )}
                </div>
              </td>
            </tr>
            <tr>
              <td className="border p-4" colSpan={5}></td>
              <td className="border p-4" colSpan={2}>
                {totals?.payments.length > 0 && (
                  <div className="rounded">
                    <h4 className="font-medium mb-2 text-gray-700">
                      PAYMENT SUMMARY
                    </h4>
                    <table className="w-full">
                      <tbody>
                        {Object.entries(groupedPayments || {}).map(
                          ([type, payments]) => {
                            const totalForType = payments.reduce(
                              (sum, p) => sum + parseFloat(p.amount || 0),
                              0,
                            );
                            return (
                              <tr key={type}>
                                <td className="py-1">{type}:</td>
                                <td className="py-1 text-right">
                                  <div>{totalForType.toFixed(3)}</div>
                                  <div className="text-gray-500 text-sm">
                                    ({payments.length} payment
                                    {payments.length !== 1 ? "s" : ""})
                                  </div>
                                </td>
                              </tr>
                            );
                          },
                        )}
                        <tr className="border-t">
                          <td className="py-2 font-medium">Total Paid:</td>
                          <td className="py-2 text-right font-medium">
                            {totals.payments
                              .reduce(
                                (sum, p) => sum + parseFloat(p.amount || 0),
                                0,
                              )
                              .toFixed(3)}
                          </td>
                          <td></td>
                        </tr>
                        <tr>
                          <td className="py-1">Remaining:</td>
                          <td className="py-1 text-right">
                            {(
                              totals.total -
                              totals.payments.reduce(
                                (sum, p) => sum + parseFloat(p.amount || 0),
                                0,
                              )
                            ).toFixed(3)}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </td>
              <td className="border p-4 text-gray-700">PAYMENT&nbsp;STATUS</td>
              <td className="border p-4" colSpan={2}>
                <div>
                  <Select
                    className="w-full"
                    name="tax"
                    placeholder="Payment status"
                    value={totals?.payment_status}
                    options={[
                      {
                        value: 0,
                        label: "Credit/Unpaid",
                      },
                      {
                        value: 1,
                        label: "Credit/Partial",
                      },
                      {
                        value: 2,
                        label: "Cash/Paid",
                      },
                    ]}
                    onChange={handlePaymentStatus}
                  />
                </div>

                {totals?.payment_status == 1 || totals?.payment_status == 2 ? (
                  <div className="pt-4">
                    <Select
                      mode="multiple"
                      className="w-full"
                      name="payment_types"
                      ref={focus.current[`payment_types`]}
                      placeholder="Payment types"
                      value={totals?.payment_types}
                      options={payment_types}
                      onChange={handlePaymentTypes}
                    />
                    <Error id={`payment_types`} />
                  </div>
                ) : (
                  ""
                )}
                {/* {totals?.payment_types?.map((value, index) => {
                  focus.current[`${value}`] = createRef();
                  return (
                    <div className="pt-4">
                      <Input
                        type="number"
                        className="w-full"
                        placeholder={value}
                        name={value}
                        ref={focus.current[`${value}`]}
                        value={totals?.payments?.[value]?.amount}
                        onChange={handlePayments}
                        autoComplete="off"
                        onKeyDown={(e) => {
                          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(e) => {
                          e.target.blur();
                        }}
                      />
                      <Error id={`${value}`} />
                    </div>
                  );
                })} */}

                {totals?.payment_types?.map((type, typeIndex) => {
                  const paymentsOfType =
                    totals.payments?.filter((p) => p.name === type) || [];

                  if (paymentsOfType.length === 0 && type) {
                    setTimeout(() => {
                      handleAddPayment(type);
                    }, 0);
                    return null;
                  }

                  return (
                    <div key={`${type}-${typeIndex}`} className="pt-4">
                      {paymentsOfType.map((payment, paymentIndex) => {
                        const uniqueId =
                          payment.id || `payment-${type}-${paymentIndex}`;
                        focus.current[`${uniqueId}`] =
                          focus.current[`${uniqueId}`] || createRef();

                        return (
                          <div key={uniqueId} className="mb-2">
                            <div className="flex items-center gap-2">
                              <span className="min-w-[100px]">
                                {type}{" "}
                                {paymentsOfType.length > 1
                                  ? `#${paymentIndex + 1}`
                                  : ""}
                              </span>
                              <Input
                                type="number"
                                className="min-w-[100px]"
                                placeholder={`${type} amount`}
                                name={`${type}_${uniqueId}`}
                                ref={focus.current[`${uniqueId}`]}
                                value={payment.amount}
                                onChange={(e) => handlePayments(e, payment.id)}
                                autoComplete="off"
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "ArrowUp" ||
                                    e.key === "ArrowDown"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onWheel={(e) => {
                                  e.target.blur();
                                }}
                              />

                              {paymentIndex === 0 && (
                                <button
                                  type="button"
                                  className="px-2 py-1 text-sm border border-green-500 text-green-500 rounded hover:bg-green-50"
                                  onClick={() => handleAddPayment(type)}
                                  title={`Add another ${type} payment`}
                                >
                                  +
                                </button>
                              )}

                              {paymentsOfType.length > 1 && (
                                <button
                                  type="button"
                                  className="px-2 py-1 text-sm border border-red-500 text-red-500 rounded hover:bg-red-50"
                                  onClick={() =>
                                    handleRemovePayment(payment.id)
                                  }
                                  title={`Remove this ${type} payment`}
                                >
                                  ×
                                </button>
                              )}
                            </div>
                            {paymentIndex === 0 && (
                              <Error id={`payment_type_${type}`} />
                            )}
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </td>
            </tr>
            <tr>
              <td className="border p-4" colSpan={7}></td>
              <td className="border p-4 text-black text-medium">TOTAL</td>
              <td className="border p-4 text-black text-medium" colSpan={2}>
                {totals?.total > 0 ? totals?.total?.toFixed(3) : "0.000"}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
});

export default Purchaseordertable;
